/*jslint browser: true */
/*global window, require */

module.exports = function()
{
	'use strict';
    const self = this || {};
	const winAlias = window;

	let storage, tracker;
	let items = [];
	let defaults = {};
	let count = 0;

	let lastSent = Date.now();
	let firstSend = true;

	self.setStorage = function (strg)
	{
		storage = strg;

		const restoreItems = storage.getStorage('q');
		if (restoreItems)
		{
			try {
				items = JSON.parse(restoreItems);
			} catch (e) {
				storage.setStorage('q', []);
			}
		}
	};

	self.setTracker = function (trk)
	{
		tracker = trk;
	};

	self.addDefault = function (key, value)
	{
		defaults[key] = value;
	};

	self.create = function ()
	{
		let ulid = require('ulid').ulid;

		let item = Object.assign({}, defaults);

		item.id = ulid();
		item.d = Date.now();
		item.c = count;
		count++;

		return item;
	};

	self.send = function(item)
	{
		items.push(item);

		self.tryFlush();
	};

	self.tryFlush = function()
	{
		storage.setStorage('q', items);

		if (firstSend)
		{
			firstSend = false;
			return setTimeout(self.flush, 500);
		}

		if (items.length > 5 || lastSent < Date.now() - 10 * 1000)
			self.flush();
	};

	self.flush = function()
	{
		if (items.length === 0)
			return true;

		tracker.transport.send(items, function(obj) {
			lastSent = Date.now();

			if (obj.success)
			{
				items = items.filter(function (item) {
					const l = obj.data.length;
					for (let i = 0; i < l; i++)
					{
						if (obj.data[i].id == item.id && obj.data[i].c == item.c)
							return false;
					}

					return true;
				});

				storage.setStorage('q', items);
			}
		});
	};

	setInterval(self.flush, 30000);

	return self;
}();
